import React from "react";
import {Document, Page, Text, View} from '@react-pdf/renderer';
import { getFileNameListForPdfWithDocument, getTextWithLines} from '../documents/helpers';
import {stylesForPdf} from './PdfPostControlStyling';
import {renderOrdersTable} from './PdfPostControlOrders';
import { draftjsToString } from '../WysiwygEditor/WysiwygHelpers';

export default class PdfControlInfo extends React.Component {


    // przekopiowane z src\Components\PdfPostControl\PdfPostControlInfo.js
    // i dostosowane do wymagań dotyczących dokumentu Pdf

    renderQuestionBlocks(blocks) {
        const blockStatuses = this.props.control?.answerBlockStatus || [];
        let firstLevel = 0;

        const Block = (
            <View>
                {
                    blocks.blocksInList && blocks.blocksInList.map(el => {
                        const blockStatus = blockStatuses.find(status => status.blockRef === el.id);
                        const notApplyToBlock = blockStatus ? blockStatus.active === false : el.questionsInBlock.every(q => q.answers?.answer === 'ND');
                        firstLevel = firstLevel + 1;
                        return (
                            <View>
                                <Text style={stylesForPdf.questionBlock}>{firstLevel + '. ' + el.name}</Text>
                                {notApplyToBlock ? <Text style={stylesForPdf.notApply}>Nie dotyczy</Text> : this.renderQuestionInBlocks(el, firstLevel)}
                            </View>
                        )
                    })
                }
            </View>
        );
        return Block;
    }

    renderQuestionInBlocks(block, firstLevel) {
        return (
            <View>
                {
                    block.questionsInBlock && block.questionsInBlock.map((el, index) => {
                      const answer = el.answers;
                      const attachments = getFileNameListForPdfWithDocument(answer?.attachments || []);
                      return (
                            <View key={el.id} style={stylesForPdf.questionContainer}>
                                <Text style={stylesForPdf.question}>{firstLevel + '.' + (index + 1) + '. ' + el.questionContent}</Text>
                                {!!answer &&
                                  <>
                                    <Text style={stylesForPdf.findingKind}>Odpowiedź: <Text style={stylesForPdf.findingKindBold}>{el.answers.answer}</Text></Text>
                                    
                                    {answer.textAnswer !== null &&
                                        <>
                                            <Text style={stylesForPdf.comment}>UWAGA:</Text>
                                            <Text style={stylesForPdf.commentContent}>{draftjsToString(answer.textAnswer)}</Text>
                                        </>
                                    }
                                    {attachments.length > 0 &&
                                        <div style={stylesForPdf.attachmentsContainer}>
                                            <Text style={stylesForPdf.attachments}>ZAŁĄCZNIKI:</Text>
                                            {attachments.map((fileName, index) =>
                                                <Text key={index} style={stylesForPdf.attachment}>{fileName}</Text>
                                            )}
                                        </div>
                                    }
                                  </>
                                }
                            </View>
                        )
                    })
                }
            </View>
        );
    }

    printPickedWops = (control) => {
		let wopsCollection = control.paymentClaims;
		if (wopsCollection?.length > 0) {
			return <Text style={stylesForPdf.tableCol60}>{wopsCollection.map(item => item.number).join(', ').match(/.{1,5}/g)}</Text>;
		} else {
			return <Text style={stylesForPdf.tableCol60}>Brak kontrolowanych wniosków</Text>
		}
	};

    render = () => {
        let {control, infoNumber} = this.props;
        let generationTime = new Date(Date.now()).toLocaleString();

        return (
            <Document>
                <Page style={stylesForPdf.body}>
                    

                    {/* nagłówek */}
                    <Text style={stylesForPdf.pageHeader} fixed>
                        {`${infoNumber}\nUtworzono ${generationTime}`}
                    </Text>

                    {/* tytuł dokumentu */}
                    <View>
                        <Text style={stylesForPdf.mainTitle}>{`Lista  sprawdzająca dla kontroli\n${infoNumber}`}</Text>
                    </View>

                    {/* informacje wstępne */}
                    <View>
                        <Text style={stylesForPdf.sectionTitle}>Informacje wstępne</Text>
                    </View>
                    <View style={stylesForPdf.sectionTitle2View}>
                        <Text style={stylesForPdf.sectionTitle2}>{getTextWithLines('Informacje o projekcie')}</Text>
                    </View>
                    <View style={stylesForPdf.tableFullWidth}>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Numer kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.number}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Numer projektu:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.project.metadata.businessId}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Tytuł projektu:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.project.title}</Text>
                        </View>
                    </View>

                    {/* Dane beneficjenta */}
                    <View style={stylesForPdf.sectionTitle2View}>
                        <Text style={stylesForPdf.sectionTitle2}>{getTextWithLines('Dane beneficjenta')}</Text>
                    </View>
                    <View style={stylesForPdf.tableFullWidth}>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Identyfikator beneficjenta:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.project.beneficiaryIdentityNumber}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Nazwa beneficjenta:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.project.beneficiaryName}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Adres beneficjenta:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.project.beneficiaryAddress}</Text>
                        </View>
                    </View>

                    {/* Informacje o kontroli */}
                    <View style={stylesForPdf.sectionTitle2View}>
                        <Text style={stylesForPdf.sectionTitle2}>{getTextWithLines('Informacje o kontroli')}</Text>
                    </View>
                    <View style={stylesForPdf.tableTopFullWidth}>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Tryb kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.controlMode}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Typ kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.controlType}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Rodzaj kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.controlKind}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Zespół kontrolujący:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.controlTeam}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Zastosowana lista sprawdzająca:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.questionList.name}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Planowany termin kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.plannedTerm}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Data rozpoczęcia kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{control.term}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Podmiot kontrolujący:</Text>
                            <Text style={stylesForPdf.tableCol60}>{(control.controllingEntity || 'Brak').split('')}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Podmioty kontrolowane:</Text>
                            <Text style={stylesForPdf.tableCol60}>{(control.allControlledParties || 'Brak').split('')}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Miejsca przeprowadzenia kontroli:</Text>
                            <Text style={stylesForPdf.tableCol60}>{(control.controlPlaces && control.controlPlaces.length > 0 ? control.controlPlaces.map(p => p.name).join("; ") : 'Brak').split('')}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Inne kontrolowane projekty:</Text>
                            <Text style={stylesForPdf.tableCol60}>{(control.otherControlledProjectNumbers && control.otherControlledProjectNumbers.length > 0 ? control.otherControlledProjectNumbers.join("; ") : 'Brak innych kontrolowanych projektów').split('')}</Text>
                        </View>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Kontrolowane zamówienia:</Text>
                            <Text style={stylesForPdf.tableCol60}>{(!control.orders || control.orders?.length === 0 ? 'Brak kontrolowanych zamówień' : '').split('')}</Text>
                        </View>
                    </View>
                    {renderOrdersTable(this.props.control.orders)}
                    <View style={!control.orders || control.orders?.length === 0 ? stylesForPdf.tableBottomNoMarginFullWidth : stylesForPdf.tableBottomFullWidth}>
                        <View style={stylesForPdf.tableRow}>
                            <Text style={stylesForPdf.tableTitleCol40}>Numery kontrolowanych WoP:</Text>
                            {this.printPickedWops(control)}
                        </View>
                    </View>

                    { control.questionList && (
                        <View>
                            <Text style={stylesForPdf.sectionQuestionBlocksTitle}>Bloki z pytaniami:</Text>
                            {this.renderQuestionBlocks(control.questionList)}
                        </View>
                    )}

                    {/* stopka */}
                    <Text style={stylesForPdf.pageNumber} render={({ pageNumber, totalPages }) => (
                        `Strona ${pageNumber} z ${totalPages}`
                    )} fixed />
                </Page>
            </Document>
        )
    };
}
